// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f15e31a6","455":"ec69cb79","977":"dc7c7400"}[chunkId] + ".chunk.js";
};